import { styled } from 'styled-components'

export const Root = styled.button`
  border: none;
  background: transparent;
  font-size: 14px;
  font-weight: 600;
  color: #35424A;
  padding: 10px;
  cursor: pointer;
`
